import { DELETE_INVITE, INVITE_USER, GET_INVITES} from './actionTypes';
import { getActionStatusName } from '@/store/helpers';

export const getInvitesStatus = state => state.status[getActionStatusName(GET_INVITES)] || {};
export const deleteInviteStatus = state => state.status[getActionStatusName(DELETE_INVITE)] || {};
export const createInviteStatus = state => state.status[getActionStatusName(INVITE_USER)] || {};
